import { Component, OnInit } from '@angular/core';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import viLocale from '@fullcalendar/core/locales/vi';
import esLocale from '@fullcalendar/core/locales/es';
import { OptionsInput } from '@fullcalendar/core';
import listPlugin from '@fullcalendar/list';
import { TeachingSchedule } from 'src/app/Utils/services/TeachingSchedule.service';
import { ResponseTeachingScheduleList } from 'src/app/Models/output.model/ResponseTeachingScheduleList';
import { common } from 'src/app/app.common';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { RequestTeachingScheduleList } from 'src/app/Models/input.model/RequestTeachingScheduleList';
import { ToastrService } from 'ngx-toastr';
import { AppConfiguration, AppConfig } from 'src/configuration';
import { Injectable, Inject } from '@angular/core';
@Component({
  selector: 'app-teaching-schedule',
  templateUrl: './teaching-schedule.component.html',
  styleUrls: ['./teaching-schedule.component.scss']
})
export class TeachingScheduleComponent implements OnInit {
  calendarPlugins = [dayGridPlugin, listPlugin];
  options: OptionsInput;
  eventsModel: any;
  EventsData: any;
  requestObject: RequestTeachingScheduleList = new RequestTeachingScheduleList()
  constructor(
    @Inject(AppConfig) 
    private readonly appConfig: AppConfiguration,
    public TeachingScheduleServirce: TeachingSchedule,
    public router: Router,
    private toastr: ToastrService
  ) { }
  public com: common;
  public ResponseTeachingScheduleListResult: ResponseTeachingScheduleList;
  locale: any
  ngOnInit() {
    this.com = new common(this.router);
    this.locale = viLocale
    this.options = {
      editable: true,
      customButtons: {
        myCustomButton: {
          text: 'custom!',
          click: function () {
            alert('clicked the custom button!');
          }
        }
      },
      header: {
        left: 'prev,next today myCustomButton',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,dayGridDay,listWeek'
      },
      minTime: "05:00",
      maxTime: "22:00",
      
    };
    this.GetSchedule()
     
  }
  help() {
    const urlHelp = this.appConfig.HelpUrl+"?"+this.appConfig.document_xem_lich_giang;
    window.open(urlHelp,'_blank');
  }
  eventClick(model) {
    
    this.toastr.info( model.event.title);
  }
  GetSchedule() {
    
    let ToDay = new Date(Date.now());
    let FromDay = new Date(ToDay.getFullYear() - 10, ToDay.getMonth(), ToDay.getDate())
    let a = this.com.getUserinfo();
    this.requestObject.UserName=a.Info.UserName;
    this.requestObject.FromDay= ToDay;
    this.requestObject.ToDay=  FromDay ;
    this.TeachingScheduleServirce.List(this.requestObject, a.Token)
    .subscribe(z => {   
      this.EventsData = z
       this.eventsModel = this.EventsData.Events
    })
  }
}
